/// <reference path="../../../../../..//typings/globals/angular-route/index.d.ts" />
/// <reference path="../../../../../..//typings/globals/angular/index.d.ts" />
/// <reference path="../../../../../../typings/globals/jquery/index.d.ts" />
/// <reference path="../../../../../../typings/globals/lodash/index.d.ts" />
/// <reference path="../../ekh/services/brandedFareTypes.service.ts" />
'use strict';

namespace ekh {


    class BrandedFareTypes {
        public flight: { [key: string]: any } = {};
        public originalCabinClass: number = 0;
        public trip: { [key: string]: any } = {};
        public loadingBrandedFareTypes: boolean;
        public savingSelectedFareType: boolean;
        public expanded: boolean;
        public brandedFareTypes: ekh.IBrandedFareType[] | undefined = undefined;
        public filteredBrandedFareTypes: ekh.IBrandedFareType[] | undefined = undefined;
        public isContainPieceBaggageConceptInLeg: boolean;
        public isContainPieceBaggageConceptOutLeg: boolean;
        public selectedBrandedFareType: ekh.IBrandedFareType;
        public defaultBrandedFareType: ekh.IBrandedFareType;
        public selectedBrandedFareTypeIndex: number = 0;
        public currency: string;
        public getPriceDifference: any;
        public qtys: any = sessionStorage.getItem('priceQtys');
        public baseCost: number = Number(sessionStorage.getItem('baseCost')) || this.basketStore.baseCostTotal();
        public priceQuantities: {
            AdultFareQuantity: number;
            AdultTaxQuantity: number;
            ChildFareQuantity: number;
            ChildTaxQuantity: number;
            InfantFareQuantity: number;
            InfantTaxQuantity: number;
        };


        constructor(
            private tripService: any,
            protected broker: Core.Broker,
            private $routeParams: ng.route.IRouteParamsService,
            private flightDetail: Core.Flights.IFlightDetailService,
            private $q: ng.IQService,
            private basketStore: any,
            private basketService: any,
            private $element: ng.IAugmentedJQuery,
            private brandedFareTypesService: ekh.BrandedFareTypesService,
            private resourceService: Core.ResourceService,
            private $filter: ng.IFilterService,
            private analytics: any,
            private occupancyService: any,
            private hotelSearch:any,
        ) { }

        $onInit(): void {
            this.loadingBrandedFareTypes = true;
            this.expanded = !TRPCONFIG.IsMobileDevice;
            this._getTrip()
                .then(this._getFlight.bind(this))
                .then(this._getBrandedFareTypes.bind(this))
                .then(this._setCurrency.bind(this))
                .finally(() => {
                    this.loadingBrandedFareTypes = false;
                });
        }

        public getTranslation(term: string): string {
            return this.resourceService.get(term);
        }

        public getPostLoadedHeader(): string {
            const priceDif = this._getStartUpgradePrice();
            if (this.filteredBrandedFareTypes && this.filteredBrandedFareTypes.length) {
                if (TRPCONFIG.IsMobileDevice || !priceDif || priceDif === '') {
                    return String.format(
                        this.getTranslation('BRANDED_FARE_TYPES_POSTLOADED_MOBILE_HEADER'),
                        this.filteredBrandedFareTypes.length, priceDif);
                } else {
                    return String.format(
                        this.getTranslation('BRANDED_FARE_TYPES_POSTLOADED_HEADER'),
                        this.filteredBrandedFareTypes.length, priceDif);
                }
            }
            return '';
        }

        public getAirports(leg): string {
            const arAir = _.get(leg, 'ArrivalAirport.Code');
            const depAir = _.get(leg, 'DepartureAirport.Code');
            return `${depAir}-${arAir}`;
        }

        private _getTrip(): ng.IPromise<Core.Trip.TripState> {
            return this.tripService.getTrip(this.$routeParams.tripId).then(trip => {
                this.trip = trip;
            });
        }

        private _setStartingSelection(brandedFareTypes) {
            let selectedFarePrice = this.selectedBrandedFareType.BrandedFareTypeTotalPrice;
            brandedFareTypes.map(function(v){
                v.IsSelected = false;
                let farePrice = v.BrandedFareTypeTotalPrice;
                farePrice = farePrice.toFixed(2);
                farePrice = Number(farePrice);
                if (farePrice === selectedFarePrice) {
                    v.IsSelected = true;
                }
            });
        }

        private async _skywardsInfo(arr, tripId, ts, bfs) {
            if (arr.length && ts) {
                let trip = await ts.getTrip(tripId).then(t => {
                    return t;
                });
                let legs = arr[0].Legs;
                let hotel = JSON.parse(sessionStorage.getItem('hotelData') || '{}');

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].IsSelected) {
                        let taxes: any = [{
                            adultTax: arr[i].AdultTax.Amount,
                            childTax: arr[i].ChildTax.Amount,
                            infantTax: arr[i].InfantTax.Amount
                        }];
                        sessionStorage.setItem('selectedFareTaxes', JSON.stringify(taxes));
                    }

                    let price = arr[i].PackagePrice;

                    if (price !== undefined && price !== null) {
                        let accruedMiles = await bfs.payloadEntry(null, trip, legs, hotel, price);
                        arr[i].AccruedMiles = accruedMiles;

                        if (arr[i].IsSelected) {
                            TRPCONFIG.Domain.SkywardsInfo = accruedMiles;
                        }
                    }

                }
            }

        }

        private _getBrandedFareTypes(): Promise<any> | ng.IPromise<void> {
            const tripId = this.trip && this.trip.TripId;
            const searchId = _.get<string>(this.trip, 'FlightsRequest.AvailabilitySearchId');
            const flightId = _.get<string>(this.trip, 'FlightsRequest.SelectedFlight.FlightId');
            if (tripId && searchId && flightId) {
                return this.flightDetail.getFlightDetails(tripId, {
                    AvailabilitySearchId: searchId,
                    FlightId: flightId,
                    IncludeSeatPlan: true,
                    MultiSector: false,
                    IncludeBrandedFares: true
                })
                    .then((details) => {
                        if (details) {
                            this._setPriceQuantities(details);
                            this._setDefaultBrandedFareType(details);
                            this._setSelectedFareType(this.flight);
                            const brandedFareTypes = _.get<ekh.IBrandedFareType[]>(
                                details, 'Itinerary.BrandedFares', [])
                                .map(b => {
                                    b.priceQuantities = this.priceQuantities;
                                    return this.brandedFareTypesService.transform(b);
                                });
                            if (!this._isExistedDefaultFareType(brandedFareTypes)) {
                                brandedFareTypes.unshift(this.defaultBrandedFareType);
                            }
                            this.brandedFareTypes = this.brandedFareTypesService.squeeze(brandedFareTypes);
                            this.isContainPieceBaggageConceptInLeg = this.brandedFareTypesService
                                .containPieceBaggageConcept(this.brandedFareTypes, 0);
                            this.isContainPieceBaggageConceptOutLeg = this.brandedFareTypesService
                                .containPieceBaggageConcept(this.brandedFareTypes, 1);

                            // This code is to get the Skywards Info
                            this._setStartingSelection(this.brandedFareTypes);
                            this.getPriceDifference = this.brandedFareTypesService
                                .getPriceDifference(this.brandedFareTypes);

                            // This is a hack to get the Skywards info for the Branded Fares
                            let si = this._skywardsInfo;
                            let ts = this.tripService;
                            let bfs = this.brandedFareTypesService;
                            let intvl = setInterval(function(){
                                if(bfs.brandedFares.length) {
                                    clearInterval(intvl);
                                    si(bfs.brandedFares, tripId, ts, bfs);
                                }
                            }, 100);

                            if (this.brandedFareTypes && this.originalCabinClass === 2) {
                                this.filteredBrandedFareTypes = this.brandedFareTypes.filter(
                                    item => item.FlightSectors[0].TransformedType >=
                                        TransformedType.PremiumEconomyFlexPlus
                                );
                            } else if (this.brandedFareTypes && this.originalCabinClass === 8) {
                                this.filteredBrandedFareTypes = this.brandedFareTypes.filter(
                                    item => item.FlightSectors[0].TransformedType >= TransformedType.BusinessSpecial
                                );
                            }
                            else if (this.brandedFareTypes && this.originalCabinClass === 4) {
                                this.filteredBrandedFareTypes = this.brandedFareTypes.filter(
                                    item => item.FlightSectors[0].TransformedType >= TransformedType.FirstSaver
                                );
                            }
                            else {
                                this.filteredBrandedFareTypes = this.brandedFareTypes;
                            }
                        }
                    });
            }
            return this.$q.when();
        }

        private _getFlight(): ng.IPromise<any> {
            if (this.trip && this.trip.BasketId) {
                return this.basketStore.flight(this.trip.BasketId).then((flight) => {
                    this.flight = _.get<{ [key: string]: any }>(flight, 'Details.Itinerary') || {};
                    this.flight.TotalAmount = flight.TotalAmount;
                    this.originalCabinClass = flight.Details.Itinerary.Legs[0].Segments[0].Cabin;
                });
            }
            return this.$q.when();
        }

        private async getPackagePrice(fare) {
            let trip = await this.tripService.getTrip(this.$routeParams.tripId).then(t => {
                return t;
            });

            let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
            let legs = fare.Legs || selectedFlight.Legs;
            let hotel = JSON.parse(sessionStorage.getItem('hotelData') || '{}');
            let qtys = JSON.parse(this.qtys);
            TRPCONFIG.Domain.FlightFare = fare;

            sessionStorage.setItem('flightFare', JSON.stringify(fare));
            let totalFares = this.brandedFareTypesService.calculateTotalFares(fare, qtys);
            let totalTaxes = this.brandedFareTypesService.calculateTotalTaxes(fare, qtys);
            let fareEachPerson = fare.AdultFare.Amount;

            if (!TRPCONFIG.Domain.TransferPrice) {
                TRPCONFIG.Domain.TransferPrice = 0;
            }

            if (this.baseCost && totalFares) {
                let packageCost = this.baseCost + totalFares + TRPCONFIG.Domain.TransferPrice;

                let accruedMiles =
                    await this.brandedFareTypesService.payloadEntry(null, trip, legs, hotel, packageCost);
                TRPCONFIG.Domain.SkywardsInfo = accruedMiles;
            }
            let origin = this.brandedFareTypesService.getDepartureCode(legs);
            let destination = this.brandedFareTypesService.getDestinationCode(legs);

            TRPCONFIG.Domain.SkywardsFlightMiles = sessionStorage.getItem('SkywardsMilesFlights');

            let fareAndFlightSelectors = fare && fare.FlightSectors;
            let fareAndFlightAndBrandtitles =
                fareAndFlightSelectors &&
                fare.FlightSectors[0].BrandTitle === fare.FlightSectors[1].BrandTitle;

            let miles = await this.brandedFareTypesService.getFareInfo
                (fareAndFlightSelectors, fareAndFlightAndBrandtitles, TRPCONFIG.Domain.SkywardsFlightMiles,
                    fare, this.hotelSearch, origin, destination, null, null);

            TRPCONFIG.Domain.SkywardsFlightMiles = miles;
            sessionStorage.setItem('SkywardsMilesFlights', miles);

        }
        private _setSelectedFareType(flight): void {
            this.getPackagePrice(flight);
            this.selectedBrandedFareType = this.brandedFareTypesService.transform({
                FlightSectors: [
                    this.flight.Legs[0],
                    this.flight.Legs[1]
                ],
                ...flight,
                priceQuantities: this.priceQuantities
            });
        }

        private _setPriceQuantities(details) {
            const quantities = [
                'AdultFareQuantity',
                'AdultTaxQuantity',
                'ChildFareQuantity',
                'ChildTaxQuantity',
                'InfantFareQuantity',
                'InfantTaxQuantity'
            ];
            this.priceQuantities = _.pick(details.Itinerary, quantities);
        }

        private _getStartUpgradePrice(): string {
            if (this.flight && this.filteredBrandedFareTypes && this.filteredBrandedFareTypes.length
                && this.selectedBrandedFareTypeIndex < this.filteredBrandedFareTypes.length - 1) {
                const defPrice = _.get<number>(
                    this.filteredBrandedFareTypes[this.selectedBrandedFareTypeIndex], 'BrandedFareTypeTotalPrice'
                );
                const firstPrice = _.get<number>(
                    this.filteredBrandedFareTypes[this.selectedBrandedFareTypeIndex + 1], 'BrandedFareTypeTotalPrice'
                );
                const dif = firstPrice - defPrice;
                return this.$filter<any>('roundedCurrency')(dif, this.currency);
            }
            return '';
        }

        private _setDefaultBrandedFareType(details): void {
            this.defaultBrandedFareType = this.brandedFareTypesService.transform({
                FlightSectors: [
                    details.Itinerary.Legs[0],
                    details.Itinerary.Legs[1]
                ],
                ...details.Itinerary,
                detailsId: details.DetailsId,
                priceQuantities: this.priceQuantities
            });
        }

        private _isEqualBrandedFareTypes(b1: ekh.IBrandedFareType, b2: ekh.IBrandedFareType): boolean {
            if (b1 && b2) {
                return b1.FlightSectors[0].TransformedType === b2.FlightSectors[0].TransformedType &&
                    b1.FlightSectors[1].TransformedType === b2.FlightSectors[1].TransformedType;
            }
            return false;
        }

        private _isExistedDefaultFareType(fareTypes: ekh.IBrandedFareType[]): boolean {
            let res = false;
            for (let i = 0; i < fareTypes.length; ++i) {
                if (this._isEqualBrandedFareTypes(this.defaultBrandedFareType, fareTypes[i])) {
                    res = true;
                    break;
                }
            }
            return res;
        }

        private _setCurrency(): void {
            return this.tripService.getCurrency(this.trip.TripId)
                .then(c => {
                    this.currency = c;
                });
        }

        public isSelectedFare(b: ekh.IBrandedFareType): boolean {
            return this._isEqualBrandedFareTypes(b, this.selectedBrandedFareType);
        }

        public initCarousel(isLastChild): void {
            if (isLastChild) {
                this.$element.find('.bft-items').slick({
                    infinite: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    nextArrow: '.next-arrow',
                    prevArrow: '.prev-arrow',
                    rtl: !!TRPCONFIG.Rtl,
                    draggable: false,
                    touchMove: false,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 4
                            }
                        }
                    ]
                });
            }
        }
        public showField() {
            let show = false;
            if (TRPCONFIG.Domain.SkywardsInfo && TRPCONFIG.Domain.SkywardsInfo[0].Miles) {
                show = true;
            }
            return show;
        }
        public resetSelection(brandedFareTypes, selectedFare) {
            for(let i = 0; i < brandedFareTypes.length; i++) {
                brandedFareTypes[i].IsSelected = false;
            }
            selectedFare.IsSelected = true;
            let bft = this.brandedFareTypesService.getPriceDifference(brandedFareTypes);
            this._skywardsInfo(bft, this.trip.TripId, null, null);
        }

        public select(selectedFare, idx): void {
            this.resetSelection(this.brandedFareTypes, selectedFare);
            this.savingSelectedFareType = true;
            this.selectedBrandedFareTypeIndex = idx;
            this.selectFare(selectedFare).then(_ => {
                this._updateBrandedFare(selectedFare);
            });
            const bLen = this.brandedFareTypes ? this.brandedFareTypes.length : 0;
            this._trackSelection(this.flight.Legs[0].ArrivalAirport.Code, idx + 1, bLen);
        }

        public selectFare(selectedFare: any): ng.IPromise<any> {
            let detailsPromise;
            if (this._isEqualBrandedFareTypes(this.defaultBrandedFareType, selectedFare)) {
                detailsPromise = this.$q.when({
                    DetailsId: this.defaultBrandedFareType.detailsId,
                    Itinerary: this.defaultBrandedFareType
                });
            } else {
                detailsPromise = this.flightDetail.getBrandSpecificFlightDetails(selectedFare.Id);
            }
            this.flight.LeadAdultPrice = selectedFare.AdultFare.Amount;
            this.flight.LeadAdultTax = selectedFare.AdultTax.Amount;
            return detailsPromise.then(details => {
                let opts: { [key: string]: any } = {
                    details,
                    searchId: _.get<string>(this.trip, 'FlightsRequest.AvailabilitySearchId'),
                    basketId: this.trip.BasketId,
                    packageId: this.trip.PackageId,
                    bags: this.flight.bags,
                    maxbags: this.occupancyService.getNumberOfNonInfantPassengers() || 1
                };
                let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
                selectedFlight.Legs = details.Itinerary.Legs;
                sessionStorage.setItem('storeSelectedFlight',JSON.stringify(selectedFlight));
                this.broker.publish('updateBrandedFareFlight',selectedFlight.Legs);
                return this.basketService.updateBrandedFare(opts);
            });
        }

        private _updateBrandedFare(selectedBrandedFare): void {
            this.savingSelectedFareType = false;
            this.selectedBrandedFareType = selectedBrandedFare;
            this.getPackagePrice(selectedBrandedFare);
        }

        private _trackSelection(airport, position, bLen): void {
            this.analytics.trackEvent({
                category: 'Branded Fares holidaysOptions',
                label: `${airport}_${position}_${bLen}`
            });
        }

    }

    angular
        .module('core')
        .directive('brandedFareTypes', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: BrandedFareTypes,
                controllerAs: 'bft',
                bindToController: {
                    flight: '='
                },
                templateUrl: 'partials/home/directivetemplate?type=BrandedFareTypes'
            };
        });
}
